/**
 * Removes CFO chat sessionStorage keys (plain and per-user `uid__` namespaced).
 * Call on logout so the next login does not inherit another account's chat UI.
 */
const CHAT_SESSION_SUFFIXES = [
    'margin_chat_messages',
    'margin_conversation_id',
    'capital_chat_messages',
    'capital_conversation_id',
    'cashflow_chat_messages',
    'cashflow_conversation_id',
    'documents_chat_messages',
    'documents_conversation_id',
    'signals_chat_messages',
    'signals_conversation_id',
];

export function clearAllChatSessionStorageKeys(): void {
    if (typeof window === 'undefined' || !window.sessionStorage) return;
    const toRemove: string[] = [];
    for (let i = 0; i < window.sessionStorage.length; i++) {
        const k = window.sessionStorage.key(i);
        if (!k) continue;
        if (CHAT_SESSION_SUFFIXES.some((s) => k === s || k.endsWith(`__${s}`))) {
            toRemove.push(k);
        }
    }
    toRemove.forEach((k) => window.sessionStorage.removeItem(k));
}
